import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Theme, Typography } from '@mui/material';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Knowledge";
import ButtonCancel from 'components/Buttons/ButtonCancel';
import ButtonSave from 'components/Buttons/ButtonSave';
import IconButtonClose from 'components/Buttons/IconButtonClose';
import { RequestIndicator } from 'components/CallServer';
import MuiMessageBox from 'components/MuiExtras/MessageBox/MuiMessageBox';
import ReorderList from 'components/ReorderList/ReorderList';
import { CourseContentDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: CourseContentDto[];
    lastError: any;
    loading: boolean;
    saving: boolean;
}

interface IProps {
    courseId: string;
    onClose: () => void;
}

type Props = IProps & WithStyles<typeof styles> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const styles = (theme: Theme) => createStyles({
    reorderItem: {
        border: "dashed 1px #000",
        marginBottom: 4
    }
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class CourseAdminReorder extends React.PureComponent<Props, IState> {

    private newListOrder: string[];

    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            lastError: null,
            loading: true,
            saving: false,
        };
    }

    ///
    private loadData() {
        this.setState({ loading: true });
        api.getCourseContent(this.props.courseId)
            .then((data: CourseContentDto[]) => {
                this.setState({ data, loading: false });
            })
            .catch((error) => {
                this.setState({ lastError: error, loading: false });
            });
    }

    ///
    private saveData() {
        this.setState({ saving: true });

        api.courseReorder(this.props.courseId, this.newListOrder)
            .then(() => {
                this.props.onClose();
            })
            .catch((error) => {
                this.setState({ saving: false });
            });
    }

    ///
    public componentDidMount() {
        this.loadData();
    }

    ///
    public render() {
        const { onClose } = this.props;
        const { data, saving, lastError, loading } = this.state;


        return (
            <Dialog
                open
                fullWidth
            >
                <DialogTitle>
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6">
                                {this.props.t("Views.Publication.Components.CourseAdminReorder.BoxTitle")}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <IconButtonClose
                                color="inherit"
                                size="small"
                                onClick={() => onClose()}
                            />
                        </Grid>
                    </Grid>
                </DialogTitle>

                <DialogContent>
                    {loading && <RequestIndicator type={"request"} />}
                    {saving && <RequestIndicator type={"post"} />}

                    {
                        lastError
                            ? <MuiMessageBox variant="error" message={this.props.t("Views.Publication.Components.CourseAdminReorder.LoadError")} />
                            : !loading
                                ? (
                                    <ReorderList
                                        className={this.props.classes.reorderItem}
                                        onMoveListItem={(newList) => { this.newListOrder = newList as string[]; }}
                                        items={
                                            data.map((item) => {
                                                return {
                                                    id: item.publicationId,
                                                    content: item.publicationTitle
                                                };
                                            })
                                        }
                                    />
                                )
                                : null
                    }
                </DialogContent>

                <DialogActions>
                    <ButtonCancel
                        onClick={() => onClose()}
                    />

                    <ButtonSave
                        color="secondary"
                        onClick={() => this.saveData()}
                    />
                </DialogActions>
            </Dialog>
        );
    }
}

export default withTranslation()(withStyles(styles)(CourseAdminReorder));